import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_3 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_4 = {
  key: 0,
  class: "absolute right-0 top-0 hidden pr-4 pt-4 sm:block"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1)

import { ref, watch } from "vue";
import {
  Dialog,
  DialogPanel,
  TransitionRoot,
  TransitionChild,
} from "@headlessui/vue";
import { XMarkIcon } from "@heroicons/vue/24/outline";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalComponent',
  props: {
    open: { type: Boolean },
    showCloseButton: { type: Boolean },
    widthClass: {}
  },
  emits: ["localModalOpen"],
  setup(__props: any, { emit: emits }) {

const props = __props;



// const emits = defineEmits()


const internalOpen = ref(props.open);

watch(
  () => props.open,
  (newVal) => {
    internalOpen.value = newVal;
  }
);

const closeModal = () => {
  internalOpen.value = false;
  emits("localModalOpen", false);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: internalOpen.value
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-50",
        onClose: closeModal
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "ease-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-200",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), {
                    class: _normalizeClass(["relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full", props.widthClass || 'max-w-2xl'])
                  }, {
                    default: _withCtx(() => [
                      (props.showCloseButton)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                              onClick: closeModal
                            }, [
                              _hoisted_5,
                              _createVNode(_unref(XMarkIcon), {
                                class: "h-6 w-6",
                                "aria-hidden": "true"
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _renderSlot(_ctx.$slots, "default")
                    ]),
                    _: 3
                  }, 8, ["class"])
                ]),
                _: 3
              })
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})